export const RAPORMIDKOLAB_GET = 'RAPORMIDKOLAB_GET';
export const RAPORSEMKOLAB_GET = 'RAPORSEMKOLAB_GET';